import { render, staticRenderFns } from "./KimsaGraph.vue?vue&type=template&id=f1bd4932&scoped=true&"
import script from "./KimsaGraph.vue?vue&type=script&lang=js&"
export * from "./KimsaGraph.vue?vue&type=script&lang=js&"
import style0 from "./KimsaGraph.vue?vue&type=style&index=0&id=f1bd4932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bd4932",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VCard,VCardText,VDivider,VFlex,VIcon,VSheet,VSparkline})
